import React from 'react';
import '../css/Header.css';

import zbrush from '../images/technologies/zbrush.png';
import maya from '../images/technologies/maya.png';
import substance from '../images/technologies/substance.png';
import marmoset from '../images/technologies/marmoset.png';
import unreal from '../images/technologies/unreal.png';
import blender from '../images/technologies/logo-blender.png';

import avatarTeacher from '../images/logo_dot.png';
import Tags from './buttons/Tags';
import dayjs from 'dayjs';
import Countdown from './Countdown';

import { useDispatch, useSelector } from 'react-redux';

import { openCounseling } from '../features/counseling';
import { openVideo } from '../features/video';

import BulletPointBlink from './buttons/BulletPointBlink';
import BulletPoint from './buttons/BulletPoint';

import Image from 'react-image-webp';

import personaje from '../images/personaje_header.png';
import imageMobile from '../images/banner_header_mobile.png';

import { MdPlayArrow, MdDownload } from 'react-icons/md';

const countdown = 'Fri, 24 Jul 2026 17:00:00 GMT-5';

const benefits = [
	'Feedback en vivo.',
	'8 meses intensivos.',
	'Material de ayuda.',
	'Acceso Discord.',
	'Certificado universitario.',
	'Acceso 1 año.',
];

const Header = () => {
	const nowDay = dayjs();
	const openingDay = dayjs(countdown);
	const bannerTop = useSelector((state) => state.banner.value.banner);

	const dispatch = useDispatch();

	const handleLink = (e) => {
		e.preventDefault();
		const target = e.target.getAttribute('href');
		const location = document.querySelector(target).offsetTop;
		window.scrollTo({
			left: 0,
			top: location - 80,
		});
	};

	const banner = useSelector((state) => state.banner.value.banner);
	const width = window.innerWidth <= 460 ? 40 : 20;

	const paddingTop = banner ? { paddingTop: width + 80 } : { paddingTop: 80 };

	return (
		<section
			className={`${'Header'} ${bannerTop ? 'paddin_section' : null}`}
			id='home'
			// style={paddingTop}
		>
			<div className='header-container container '>
				<div className='header-content'>
					<Image
						src={personaje}
						webp={personaje}
						alt='Máster en Blender'
						className='header-image'
					/>
					<Image
						src={imageMobile}
						webp={imageMobile}
						alt='Máster en Blender'
						className='header-image-mobile'
					/>
					<div className='header-item'>
						<BulletPoint color={'#77bf41'} />
						<p>Feedback en vivo</p>
					</div>
					<h1 className='header-title'>
						Máster en
						<br />
						<span>ZBrush </span>
					</h1>

					<p className='header-p'>Creación de Orco: Escultura de Criaturas Fantásticas</p>
					<div className='header-buttons'>
						<button
							className='header-button see-trailer'
							onClick={() => {
								dispatch(
									openVideo({
										modal: true,
										url: 'https://youtu.be/4M4LZ3xt-RA',
										type: 'common',
									})
								);
							}}
						>
							Ver trailer
							<MdPlayArrow />
						</button>

						<a
							href='#contenido'
							// target='blank_'
							className='header-button see-payment'
							// onClick={handleLink}
						>
							Temario
							<MdDownload />
						</a>
					</div>
					<div className='master-benefits'>
						{benefits.map((benefit, index) => (
							<div key={index} className='header-item' style={{ fontWeight: 'normal' }}>
								<BulletPoint color={'#8b53fe'} />
								<p>{benefit}</p>
							</div>
						))}
					</div>
				</div>

				<div className='header-information'>
					<div className='header-information-content'>
						<img src={avatarTeacher} alt='Avatar Teacher' />
						<h2>
							Agenta tu
							<br />
							asesoría gratis
						</h2>
						<Tags name={'Solicita asesoría'} />
						{openingDay.isAfter(nowDay) ? (
							<Countdown countdownTimestampMs={countdown} />
						) : (
							<h3 className='start-master'>
								<BulletPointBlink color={'#77bf41'} />
								<span>Ya inició</span>
							</h3>
						)}
						<a href='#entrenamientos' className='payment' onClick={handleLink}>
							Inscríbete ahora
						</a>
						{/* <a href='#metodos-de-pago' className='to-payment-methods' onClick={handleLink}>
							MÉTODOS DE PAGO
						</a> */}
						<button
							className='payment-information'
							onClick={() => {
								dispatch(openCounseling());
							}}
						>
							* Pregunta por nuestros planes
							<br /> de financiación.
						</button>
					</div>
					<div className='header-information-technologies'>
						<img src={blender} alt='technology' style={{ maxWidth: '31px' }} />
						<img src={substance} alt='technology' />
						<img src={unreal} alt='technology' />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Header;
